// @module Eureka.MaxaItemBrands.MaxaItemBrands
define('Eureka.MaxaItemBrands.MaxaItemBrands.View'
,	[
	'eureka_maxaitembrands_maxaitembrands.tpl'
	
	,	'Eureka.MaxaItemBrands.MaxaItemBrands.SS2Model'
	
	,	'Backbone'
    ]
, function (
	eureka_maxaitembrands_maxaitembrands_tpl
	
	,	MaxaItemBrandsSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class Eureka.MaxaItemBrands.MaxaItemBrands.View @extends Backbone.View
	return Backbone.View.extend({

		template: eureka_maxaitembrands_maxaitembrands_tpl

	,	initialize: function (options) {
			console.log("options", options)
			var pdp = options.container.getComponent('PDP');
			var iteminfo = pdp.getItemInfo();
			console.log(iteminfo);
			if(iteminfo.item){
				this.model = new MaxaItemBrandsSS2Model();
				var self = this;
				this.model.fetch({data: {
					id: iteminfo.item.internalid
					}}).done(function(result) {
						console.log(result);
						if(!result){
							self.show = false
						}else {
							self.result = result
							self.show = true
							self.showAlt = (result.altImage)
						}
					self.render()
				})
			}

		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Eureka.MaxaItemBrands.MaxaItemBrands.View.Context
	,	getContext: function getContext()
		{
			return {
				result: this.result,
				show: this.show,
				showAlt: this.showAlt
			};
		}
	});
});
